import { feature as promotionsBannersFlowFeature } from '@central-products/promotions-banners-flow';

export const promotionsBannersFlowPlugin = {
  beforeBootstrap({ addBootstrapperFeature }) {
    addBootstrapperFeature(promotionsBannersFlowFeature);
  },
};
